export function clearLocalStorageKeyOnce(targetKey: string, flagKey = 'localStorageCleared') {
  // check if we've already cleared this key before
  if (!localStorage.getItem(flagKey)) {
    localStorage.removeItem(targetKey);
    localStorage.setItem(flagKey, 'true');
  }
}
